<template>
  <h1>Courses & Programs (Coming Soon)</h1>
</template>

<script>
export default {
  name: 'CoursesPrograms',
}
</script>

<style scoped></style>
